export const PopoverIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 118C53 114.686 55.6863 112 59 112H341C344.314 112 347 114.686 347 118V241C347 244.314 344.314 247 341 247H59C55.6863 247 53 244.314 53 241V118Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71 134.5C71 132.015 73.0147 130 75.5 130H142.5C144.985 130 147 132.015 147 134.5C147 136.985 144.985 139 142.5 139H75.5C73.0147 139 71 136.985 71 134.5Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71 157.5C71 155.015 73.0147 153 75.5 153H292.5C294.985 153 297 155.015 297 157.5C297 159.985 294.985 162 292.5 162H75.5C73.0147 162 71 159.985 71 157.5Z'
      fill='#CBD5E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71 174.5C71 172.015 73.0147 170 75.5 170H322.5C324.985 170 327 172.015 327 174.5C327 176.985 324.985 179 322.5 179H75.5C73.0147 179 71 176.985 71 174.5Z'
      fill='#CBD5E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71 191.5C71 189.015 73.0147 187 75.5 187H272.5C274.985 187 277 189.015 277 191.5C277 193.985 274.985 196 272.5 196H75.5C73.0147 196 71 193.985 71 191.5Z'
      fill='#CBD5E0'
    />
    <path
      d='M320.22 139.719C320.079 139.86 320 140.05 320 140.249C320 140.448 320.079 140.639 320.22 140.779C320.36 140.92 320.551 140.999 320.75 140.999C320.949 140.999 321.14 140.92 321.28 140.779L325.911 136.149C325.923 136.138 325.936 136.128 325.952 136.122C325.967 136.116 325.983 136.113 326 136.113C326.016 136.113 326.032 136.116 326.047 136.122C326.063 136.128 326.076 136.138 326.088 136.149L330.719 140.78C330.788 140.85 330.871 140.905 330.962 140.943C331.053 140.981 331.15 141 331.249 141C331.347 141 331.445 140.981 331.536 140.943C331.627 140.905 331.71 140.85 331.779 140.78C331.849 140.711 331.904 140.628 331.942 140.537C331.98 140.446 331.999 140.349 331.999 140.25C331.999 140.152 331.98 140.054 331.942 139.963C331.904 139.872 331.849 139.79 331.78 139.72L327.149 135.088C327.138 135.076 327.129 135.063 327.122 135.047C327.116 135.032 327.113 135.016 327.113 134.999C327.113 134.983 327.116 134.967 327.122 134.952C327.129 134.936 327.138 134.923 327.149 134.911L331.781 130.281C331.921 130.14 332 129.949 332 129.75C332 129.551 331.921 129.36 331.78 129.219C331.639 129.079 331.448 129 331.249 129C331.05 129 330.859 129.079 330.719 129.22L326.088 133.85C326.076 133.861 326.063 133.87 326.047 133.877C326.032 133.883 326.016 133.886 326 133.886C325.983 133.886 325.967 133.883 325.952 133.877C325.936 133.87 325.923 133.861 325.911 133.85L321.28 129.22C321.211 129.15 321.128 129.095 321.037 129.058C320.946 129.02 320.849 129 320.75 129C320.551 129 320.36 129.079 320.22 129.22C320.079 129.361 320 129.551 320 129.75C320 129.949 320.079 130.14 320.22 130.281L324.85 134.911C324.861 134.923 324.871 134.936 324.877 134.952C324.883 134.967 324.886 134.983 324.886 134.999C324.886 135.016 324.883 135.032 324.877 135.047C324.871 135.063 324.861 135.076 324.85 135.088L320.22 139.719Z'
      fill='#718096'
    />
    <path
      d='M260 215C260 212.791 261.791 211 264 211H328C330.209 211 332 212.791 332 215V228C332 230.209 330.209 232 328 232H264C261.791 232 260 230.209 260 228V215Z'
      fill='#38B2AC'
    />
    <path
      d='M172 215C172 212.791 173.791 211 176 211H240C242.209 211 244 212.791 244 215V228C244 230.209 242.209 232 240 232H176C173.791 232 172 230.209 172 228V215Z'
      fill='#E2E8F0'
    />
    <path
      d='M198.15 103.373C198.946 102.225 200.643 102.225 201.438 103.373L207.588 112.25H192L198.15 103.373Z'
      fill='white'
    />
    <path
      d='M138 63C138 58.5817 141.582 55 146 55H253C257.418 55 261 58.5817 261 63V87C261 91.4183 257.418 95 253 95H146C141.582 95 138 91.4183 138 87V63Z'
      fill='#38B2AC'
    />
    <path
      d='M164.091 75C164.091 72.2386 166.329 70 169.091 70H229.909C232.67 70 234.909 72.2386 234.909 75C234.909 77.7614 232.67 80 229.909 80H169.091C166.329 80 164.091 77.7614 164.091 75Z'
      fill='#F7FAFC'
    />
  </svg>
)
